import type { RootState } from "@src/store/rootState";
import { ProductPickerType } from "@src/store/slices/productPicker/types";

export const isProductPickerOpen =
  (type?: ProductPickerType) => (state: RootState) => {
    if (type) {
      return state.productPicker.data?.type === type;
    } else {
      return state.productPicker.data !== undefined;
    }
  };
